import React, { useCallback, useMemo, useState } from 'react'

import { getIntegrationDisplayName } from '../../../common/integrations'

import { CRM_ACTION_REGISTRY, type CrmActionKind } from './crmActionRegistry'
import { CrmActionHostContext, type CrmActionHostContextValue, type CrmActionHostOpenArgs } from './useCrmActionHost'

interface ActiveModal {
  kind: CrmActionKind
  args: CrmActionHostOpenArgs
}

export const CrmActionHostProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [active, setActive] = useState<ActiveModal | null>(null)

  const open = useCallback((kind: CrmActionKind, args: CrmActionHostOpenArgs) => {
    setActive({ kind, args })
  }, [])

  const close = useCallback(() => {
    setActive(null)
  }, [])

  const value = useMemo<CrmActionHostContextValue>(() => ({ open, close }), [open, close])

  const activeDescriptor = active ? CRM_ACTION_REGISTRY[active.kind] : null
  const ActiveModalComponent = activeDescriptor ? activeDescriptor.Modal : null

  return (
    <CrmActionHostContext.Provider value={value}>
      {children}
      {ActiveModalComponent && active && activeDescriptor ? (
        <ActiveModalComponent
          open
          onClose={close}
          resolveResults={active.args.resolveResults}
          tracking={{
            platform: getIntegrationDisplayName(activeDescriptor.serviceId),
            action: activeDescriptor.label,
            scope: active.args.scope,
          }}
        />
      ) : null}
    </CrmActionHostContext.Provider>
  )
}
